
export class MCName {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "MCName";
    this.scene = "MCName";
    this.data = [];
    this.page = 9006;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "1100";
      }).value = (options?.game?.mc?.first_name.toUpperCase()  || "") + " " + (options?.game?.mc?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1101";
      }).value = "MASTER OF CEREMONIES";
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1201";
      }).value = "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "1203";
      }).value = "0";
      

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
